import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import img1 from "../../assets/images/Image-1.svg";
import img2 from "../../assets/images/image-2.svg";
import img3 from "../../assets/images/image-3.svg";

const AboutSection: React.FC = () => {
  return (
    <section className="about-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Images */}
          <Col md={6} className="image-collage">
            <div className="img-box img1">
              <img src={img1} alt="img1" />
            </div>
            <div className="img-box img2">
              <img src={img2} alt="img2" />
            </div>
          </Col>

          {/* Right Content */}
          <Col md={6}>
            <span className="about-badge">ABOUT US</span>
            <h2 className="about-title">Welcome to Chipnest Semiconductor.</h2>

            <p>
              Chipnest Semiconductor is an advanced VLSI services company delivering
              cutting-edge and high-performance semiconductor solutions. Our
              expertise spans front-end design, back-end implementation, design
              verification, synthesis, and physical design.
            </p>

            <p>
              Our team has expertise in wide range of domains and advanced
              technology nodes including 3nm, 5nm, 7nm.
            </p>

            <p>
              We empower clients to bring next-generation products to market
              with speed and precision.
            </p>
            <img src={img3} alt="img3" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
